const cards = [
  {
    title: '霸道总裁的契约新娘',
    tag: '韩漫·恋爱',
    desc: '热门韩漫恋爱神作，契约婚姻中暗藏真心，高甜剧情让人欲罢不能，千万读者追更中。',
    heat: '362万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manga%20cover%20style%20illustration%2C%20beautiful%20couple%20in%20warm%20sunset%20light%2C%20soft%20pastel%20colors%2C%20elegant%20character%20design%2C%20clean%20background%2C%20manga%20cover%20aesthetic%2C%20dreamy%20romantic%20atmosphere&width=400&height=560&seq=qinqin-card-01&orientation=portrait',
  },
  {
    title: '剑与魔法的异世界',
    tag: '日漫·热血',
    desc: '日漫奇幻冒险巨作，少年剑士穿越异世界展开史诗级战斗，画风精良剧情紧凑。',
    heat: '458万',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20action%20manga%20cover%20style%2C%20dynamic%20samurai%20warrior%20pose%2C%20dramatic%20ink%20brush%20effects%2C%20bold%20red%20and%20black%20color%20scheme%2C%20powerful%20composition%2C%20clean%20background%2C%20manga%20cover%20aesthetic&width=400&height=560&seq=qinqin-card-02&orientation=portrait',
  },
  {
    title: '修仙大佬在现代',
    tag: '国漫·奇幻',
    desc: '国漫修仙题材人气作品，隐世高手融入都市生活，轻松搞笑与热血战斗并存的佳作。',
    heat: '289万',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20style%2C%20cultivation%20immortal%20character%20in%20flowing%20robes%2C%20ethereal%20mountain%20landscape%2C%20soft%20golden%20and%20jade%20colors%2C%20elegant%20ink%20painting%20style%2C%20clean%20background%2C%20manhua%20cover%20aesthetic&width=400&height=560&seq=qinqin-card-03&orientation=portrait',
  },
  {
    title: '我们的青春物语',
    tag: '日漫·校园',
    desc: '校园青春日漫温情之作，记录一群少年的成长与梦想，细腻画风打动无数读者内心。',
    heat: '215万',
    image: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20manga%20cover%20style%2C%20group%20of%20young%20friends%20in%20school%20uniform%2C%20cherry%20blossom%20spring%20scene%2C%20soft%20warm%20lighting%2C%20pastel%20color%20palette%2C%20clean%20background%2C%20manga%20cover%20aesthetic%2C%20heartwarming%20atmosphere&width=400&height=560&seq=qinqin-card-04&orientation=portrait',
  },
  {
    title: '暗夜追踪者',
    tag: '韩漫·悬疑',
    desc: '韩漫悬疑推理力作，天才侦探搭档追踪连环案件，层层反转扣人心弦，全程高能无尿点。',
    heat: '176万',
    image: 'https://readdy.ai/api/search-image?query=Thriller%20mystery%20manga%20cover%20style%2C%20detective%20character%20in%20dark%20alley%2C%20dramatic%20lighting%20and%20shadows%2C%20moody%20cool%20tone%20color%20scheme%2C%20suspenseful%20composition%2C%20clean%20background%2C%20manga%20cover%20aesthetic&width=400&height=560&seq=qinqin-card-05&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-secondary-100/50 mb-3">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`亲亲漫画 ${card.tag} - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-2 left-2 px-2 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-800">
                  {card.tag}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {card.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{card.desc}</p>
              <p className="mt-2 text-xs text-primary-600 font-medium">
                <i className="ri-fire-line mr-1"></i>{card.heat} 热度
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}